import styles from './cookiesPopup.module.scss'
import { useEffect } from 'react'
import { Container } from 'layout/container'
import { useState } from 'react'
import { useCookies } from 'hooks/useCookies'
import { usePageProperties } from 'hooks/usePageProperies'
import { Text } from 'typography/text'

const CookiesPopup = () => {
  const { cookies = {} } = usePageProperties()
  const newCookies = useCookies()
  const [activePopup, setActivePopup] = useState(cookies?.cookieAgree !== 'yes')
  const [showPopup, setShowPopup] = useState(true)
  const [scrollTop, setScrollTop] = useState(0)

  const detectScroll = (e) => {
    setScrollTop(e.target.documentElement.scrollTop)
  }

  const handleClose = () => {
    setActivePopup(false)
  }

  useEffect(() => {
    window.addEventListener('scroll', detectScroll)
    setShowPopup(scrollTop <= 100)
  }, [scrollTop])

  const applyCookies = () => {
    let now = new Date()
    let expires = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate())
    setActivePopup(false)
    newCookies.set('cookieAgree', 'yes', { path: '/', expires })
  }

  if (!activePopup || !showPopup) return ''

  return (
    <div className={styles.cookiesPopup__wrapper}>
      <Container className={styles.cookiesPopup__container}>
        <Text className={styles.cookiesPopup__text}>
          We use cookies to give you the best experience on our website. By continuing to use our
          website you agree to our <a href="/privacy">Privacy Policy</a>.
        </Text>
        <div className={styles.cookiesPopup__buttonsBlock}>
          <button className={styles.cookiesPopup__btn} onClick={applyCookies}>
            ok
          </button>
          <button className={styles.cookiesPopup__close} onClick={handleClose} />
        </div>
      </Container>
    </div>
  )
}

export { CookiesPopup }
